// extracted by mini-css-extract-plugin
module.exports = {"toggleLayout":"styles_toggleLayout__9PM5y","togglePrivate":"styles_togglePrivate__Fq7Qe"};